import { render, staticRenderFns } from "./ech-side-menu-item.vue?vue&type=template&id=554741e1&"
import script from "./ech-side-menu-item.vue?vue&type=script&lang=js&"
export * from "./ech-side-menu-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports